import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  DownloadQuoteListCsvQueryVars,
  UseDownloadQuoteListCsvParams,
} from './types';

export const useDownloadQuoteListCsv: MutationFunction<
  string,
  DownloadQuoteListCsvQueryVars,
  [UseDownloadQuoteListCsvParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { locator } = params;
  const urlPath = `/quotes/groups/${locator}/export`;
  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) => {
      return request(urlPath, {
        init: {
          method: 'GET',
        },
        query: requestData,
        shouldConvertQueryKeysToSnakeCase: false,
      });
    },
    {
      ...queryOptions,
      mutationKey: ['quotes', 'quoteList', 'downloadQuoteListCsv'],
    },
  );
};
